<template>
  <div>
    <div class="page-title">
      {{ $t('data.payin_transaction') }}
    </div>
    <div class="page-container">

      <PayinTransDetails />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Data_Payin',
  components: {
    PayinTransDetails: () => import('./components/PayinTransDetails.vue')
  }
}
</script>

<style scoped>
.page-container{

}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
